import {Navigate, Outlet, useLocation} from 'react-router-dom'
import {useAuth} from '../../context/authContext'
import * as RouterWays from '../../enums/routes'

const ProtectedRoute = () => {
  const {isLoggedIn} = useAuth()
  const location = useLocation()

  if (!isLoggedIn) {
    return <Navigate to={RouterWays.HOME} replace state={{from: location}}/>
  }

  return <Outlet/>
}

export default ProtectedRoute